import axios, { buildApi } from '@/libs/api.request';
let name = '/shipments/ChangeOrder'

export const apis = buildApi({
  get: [name + '/index&list',],
  post: [name + '/save']
})